<script>
import ApiService from "../utils/ApiService";
import Pagination from "../mixins/Pagination";

export default {
    name: "VendorTransactions",
    //mixins:[Pagination],
    data() {
        return {
            loading: true,
            vendor: {},
            transactions: []
        }
    },
    methods: {
        fetchTransactions() {
            this.loading = true;
            ApiService.get('/buildium/vendors/' + this.$route.params.id + '/transactions').then(response => {
                this.transactions = response.data;
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        ApiService.get('/buildium/vendors/' + this.$route.params.id).then(response => {
            console.log(response.data);
            this.vendor = response.data;
        }).catch(reason => {
            this.$message.error(reason.message);
        }).finally(() => {
            this.loading = false;
        });
        this.fetchTransactions();
    }
}
</script>

<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <h2 class="flex-grow-1">Vendors Transactions</h2>
        </div>
        <section class="page-section">
            <h3>{{ vendor.CompanyName }}</h3>
        </section>
        <section class="page-section" v-loading="loading">
            <div class="tablenav tablenav-top">
                <h3>Transactions</h3>
            </div>
            <el-table :data="transactions">
                <el-table-column prop="Memo" label="Memo"></el-table-column>
                <el-table-column prop="ReferenceNumber" label="Reference Number" width="200"></el-table-column>
                <el-table-column prop="TotalAmount" label="Total Amount" width="160"></el-table-column>
                <el-table-column prop="TransactionType" label="Transaction Type" width="200"></el-table-column>
                <el-table-column prop="Date" label="Paid Date" width="140"></el-table-column>
                <el-table-column label="Actions" width="100" align="right">
                    <template slot-scope="scope">
                        <a :href="scope.row.links.pdf.href" target="_blank">PDF</a>
                        <span>|</span>
                        <a>Send</a>
                    </template>
                </el-table-column>
            </el-table>
        </section>
    </main-layout>
</template>

<style scoped>

</style>